import React, { useMemo } from 'react'
import { TaboolaForDiv } from './TaboolaForDiv'
import {
  PocTaboolaList,
  PocTaboolaPageType,
  PocTaboolaSuffixId,
} from './TaboolaTypes'
import { utils } from '../Player/Helpers'
import { useTaboola } from './useTaboola'
import { usePageMeta } from '../../contexts'

type Props = {
  pageType: PocTaboolaPageType | typeof PocTaboolaList | string
  index?: number
  suffixId: PocTaboolaSuffixId
}

export const Taboola = ({ pageType, index, suffixId }: Props) => {
  const { taboolaInfo } = useTaboola()
  const PageMeta = usePageMeta()
  const taboolaDisabled = useMemo(() => {
    if (!PageMeta || !PageMeta.ads) {
      return false
    }
    return PageMeta.ads.block.taboola
  }, [PageMeta])

  if (!taboolaInfo.isTaboolaReady || taboolaDisabled) {
    return null
  }

  return (
    <TaboolaForDiv
      key={`${pageType}-${suffixId}-${index}-${utils.getPageViewedInSession()}`}
      pageType={pageType}
      index={index}
      suffixId={suffixId}
      os={taboolaInfo.os}
      pub={taboolaInfo.taboolaPubName}
    />
  )
}
